export const OpenModal = () => {
  var element = document.getElementById("hd-header-perfil-usuario");
  if (element === undefined || element === null) return;

  element.style.display = "flex";
};

export const CloseModal = ({ target }) => {
  if (target.id === "hd-header-perfil-usuario") {
    var element = document.getElementById("hd-header-perfil-usuario");
    if (element === undefined || element === null) return;
  
    element.style.display = "none";
  }
};
